import { Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PurchaseRequestTable from "../../../components/Table/DocumentTable/PurchaseRequestTable";
import { getPurchaseRequestTab } from "../../../features/Sales/SalesOrder/sales-order-actions";

const PurchaseRequestTab = () => {
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const { purchaseRequestTab } = useSelector((state) => state.salesOrder);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const gridRef = useRef();

  useEffect(() => {
    if (id) {
      dispatch(getPurchaseRequestTab(id, enqueueSnackbar));
    }
  }, [dispatch, enqueueSnackbar, id]);

  return (
    <>
      <Typography variant="h5" sx={{ ml: 1, mb: 4 }}>
        {t("purchase.request.index")}
      </Typography>
      <PurchaseRequestTable gridRef={gridRef} rowData={purchaseRequestTab} />
    </>
  );
};

export default PurchaseRequestTab;
